import { Events } from '|>/shared/events'
import { on, register } from '|>/shared/vjs'
import { BaseLiveTracker } from '../base'

@register
export class LiveTracker extends BaseLiveTracker {
  declare options_: any

  @on(Events.Media.IsRewound)
  private isRewound: Events.Media.IsRewound = false

  @on(Events.Media.IsAutoLiveTracker)
  private isAutoLiveTracker: Events.Media.IsAutoLiveTracker = false

  override toggleTracking() {
    if (this.isAutoLiveTracker) return super.atLiveEdge()

    if (
      this.player_.duration() === Infinity &&
      this.liveWindow() >= this.options_.trackingThreshold
    ) {
      this.startTracking()
    } else {
      this.stopTracking()
    }
  }

  override atLiveEdge() {
    if (this.isAutoLiveTracker) return super.atLiveEdge()

    return !this.isRewound
  }

  override seekToLiveEdge() {
    // this behaviour should not be allowed when in rewind, "go live" handled by app.
    if (this.isRewound) return

    super.seekToLiveEdge()
  }
}

// Default values
LiveTracker.options = {
  // liveTolerance: 10, // Default: 15s
  trackingThreshold: 0, // Default: 20s // no metter stream dur. - live ui is shown
}
